import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/animal-debt/client-comma.webp";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

function Clientanimialslider() {
  return (
    <section className="client-animial-slider p-100">
      <Container>
        <Row className="mb-4 mb-md-5">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={8}
            xxl={7}
            className="m-auto text-center"
          >
            <h2 style={{ color: "#202020" }}>
              Client <span className="purple-box">Success </span>
            </h2>
            <h3 style={{ color: "#202020" }}>
              How Schology Met Expectations and Changed Education
            </h3>
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={7}
            xxl={7}
            className="m-auto text-center"
          >
            <Swiper
              loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              //   autoplay={false}
              spaceBetween={20}
              modules={[Autoplay]}
              pagination={{ clickable: true }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 1,
                },
                1024: {
                  slidesPerView: 1,
                },
                1366: {
                  slidesPerView: 1,
                },
                1600: {
                  slidesPerView: 1,
                },
              }}
              className="client-test"
            >
              <SwiperSlide>
                <div
                  className="client-box"
                  style={{
                    backgroundImage: `url(${BgImg})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div className="stars">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="166"
                      height="30"
                      fill="none"
                      viewBox="0 0 166 30"
                    >
                      <path
                        fill="#565CCF"
                        d="m6.53 29.34 2.386-10.664-8.002-7.174 10.57-.948L15.597.496l4.11 10.058 10.571.948-8.001 7.173 2.386 10.665-9.066-5.655zM74.385 29.34l2.386-10.664-8.002-7.174 10.571-.948L83.451.496l4.11 10.058 10.572.948-8.002 7.173 2.386 10.665-9.066-5.655zM40.458 29.34l2.385-10.664-8.001-7.174 10.57-.948L49.524.496l4.111 10.058 10.57.948-8 7.173 2.385 10.665-9.066-5.655zM108.314 29.34l2.386-10.664-8.002-7.174 10.571-.948L117.38.496l4.111 10.058 10.57.948-8.001 7.173 2.386 10.665-9.066-5.655zM142.242 29.34l2.385-10.664-8.001-7.174 10.571-.948L151.308.496l4.11 10.058 10.571.948-8.001 7.173 2.385 10.665-9.065-5.655z"
                      ></path>
                    </svg>
                    <span>(5.0)</span>
                  </div>
                  <p>
                    The onboarding of over 100 schools is a strong indication of
                    client’s satisfaction with the platform. The client has
                    consistently expressed confidence in Schology’s ability to
                    meet their goals for improved communication, streamlined
                    resource management, and enhanced data visibility,
                    solidifying its role as a game-changer in education.
                  </p>
                  {/* <h6>Gray</h6>
                  <h5>Game Developer and Reviewer</h5> */}
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  className="client-box"
                  style={{
                    backgroundImage: `url(${BgImg})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div className="stars">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="166"
                      height="30"
                      fill="none"
                      viewBox="0 0 166 30"
                    >
                      <path
                        fill="#565CCF"
                        d="m6.53 29.34 2.386-10.664-8.002-7.174 10.57-.948L15.597.496l4.11 10.058 10.571.948-8.001 7.173 2.386 10.665-9.066-5.655zM74.385 29.34l2.386-10.664-8.002-7.174 10.571-.948L83.451.496l4.11 10.058 10.572.948-8.002 7.173 2.386 10.665-9.066-5.655zM40.458 29.34l2.385-10.664-8.001-7.174 10.57-.948L49.524.496l4.111 10.058 10.57.948-8 7.173 2.385 10.665-9.066-5.655zM108.314 29.34l2.386-10.664-8.002-7.174 10.571-.948L117.38.496l4.111 10.058 10.57.948-8.001 7.173 2.386 10.665-9.066-5.655zM142.242 29.34l2.385-10.664-8.001-7.174 10.571-.948L151.308.496l4.11 10.058 10.571.948-8.001 7.173 2.385 10.665-9.065-5.655z"
                      ></path>
                    </svg>
                    <span>(5.0)</span>
                  </div>
                  <p>
                    The onboarding of over 100 schools is a strong indication of
                    client’s satisfaction with the platform. The client has
                    consistently expressed confidence in Schology’s ability to
                    meet their goals for improved communication, streamlined
                    resource management, and enhanced data visibility,
                    solidifying its role as a game-changer in education.
                  </p>
                  {/* <h6>Gray</h6>
                  <h5>Game Developer and Reviewer</h5> */}
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  className="client-box"
                  style={{
                    backgroundImage: `url(${BgImg})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div className="stars">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="166"
                      height="30"
                      fill="none"
                      viewBox="0 0 166 30"
                    >
                      <path
                        fill="#565CCF"
                        d="m6.53 29.34 2.386-10.664-8.002-7.174 10.57-.948L15.597.496l4.11 10.058 10.571.948-8.001 7.173 2.386 10.665-9.066-5.655zM74.385 29.34l2.386-10.664-8.002-7.174 10.571-.948L83.451.496l4.11 10.058 10.572.948-8.002 7.173 2.386 10.665-9.066-5.655zM40.458 29.34l2.385-10.664-8.001-7.174 10.57-.948L49.524.496l4.111 10.058 10.57.948-8 7.173 2.385 10.665-9.066-5.655zM108.314 29.34l2.386-10.664-8.002-7.174 10.571-.948L117.38.496l4.111 10.058 10.57.948-8.001 7.173 2.386 10.665-9.066-5.655zM142.242 29.34l2.385-10.664-8.001-7.174 10.571-.948L151.308.496l4.11 10.058 10.571.948-8.001 7.173 2.385 10.665-9.065-5.655z"
                      ></path>
                    </svg>
                    <span>(5.0)</span>
                  </div>
                  <p>
                    The onboarding of over 100 schools is a strong indication of
                    client’s satisfaction with the platform. The client has
                    consistently expressed confidence in Schology’s ability to
                    meet their goals for improved communication, streamlined
                    resource management, and enhanced data visibility,
                    solidifying its role as a game-changer in education.
                  </p>
                  {/* <h6>Gray</h6>
                  <h5>Game Developer and Reviewer</h5> */}
                </div>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Clientanimialslider;
